export enum PointEventType {
  PointCreated = 'pointCreated',
  PointDeleted = 'pointDeleted',
}
